module.exports = __webpack_public_path__ + "static/logo-cdp-circle-fd4e9510c572a903219997bddb11068a.png";